module.exports = __webpack_public_path__ + "661b931c2b1b847ca8e76cff27a1fea7.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/5/SpotinxArctic15.png
// module id = 246
// module chunks = 0